export var COLLAPSE="COLLAPSE";export var TOGGLE="TOGGLE";export var COLLAPSE_ALL="COLLAPSE_ALL";